import script from "./BlogPage.vue?vue&type=script&setup=true&lang=js"
export * from "./BlogPage.vue?vue&type=script&setup=true&lang=js"

import "./BlogPage.vue?vue&type=style&index=0&id=7fedd8fa&lang=css"

const __exports__ = script;

export default __exports__